import * as React from "react";

import { WorkspaceDropdown } from "components/common/WorkspaceDropdown";
import { useAppSidebarLayout } from "./appSidebarLayout";

/**
 * Top of every sidebar: the workspace switcher, then an optional slot.
 * Search lives in the app header, so the sidebar stays navigation only.
 */
export const AppSidebarHeader = ({ children }: { children?: React.ReactNode }) => {
  const { collapsed } = useAppSidebarLayout();
  return (
    <>
      <WorkspaceDropdown collapsed={collapsed} />
      {children}
    </>
  );
};
